<template>
    <div class="gas-table">
        <div class="menu-wrap">
            <el-form :inline="true" >
                <el-form-item label="开始时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="start_date"
                    type="date"
                    class="start_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="start_time"
                    class="start_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>
        
                <el-form-item label="结束时间">
                    <!--日期-->
                    <el-date-picker
                    v-model="end_date"
                    type="date"
                    class="end_date date-input"
                    placeholder="开始日期"
                    @change="timeChange">
                    </el-date-picker>
                    <!--时间-->
                    <el-time-select
                    v-model="end_time"
                    class="end_time time-input"
                    placeholder="请选择"
                    @change="timeChange">
                    </el-time-select>
                </el-form-item>

                <el-form-item label="选择预设时间">
                    <el-select placeholder="预设时间" v-model="time_range" class="time_range" @change="timeRangeChange">
                        <el-option label="自定义" value="customize"></el-option>
                        <el-option label="最近一天" value="day"></el-option>
                        <el-option label="最近一周" value="week"></el-option>
                        <el-option label="最近一月" value="month"></el-option>
                        <el-option label="最近一年" value="year"></el-option>
                    </el-select>
                </el-form-item>
                
                <el-button plain type="primary" class="menu-btn" @click="searchData()">
                    查询
                </el-button>

                <el-button plain type="primary" class="menu-btn" @click="showSitesSelect">
                    站点筛选
                </el-button>

                <!--数据导出-->
                <!-- <download-excel 
                    class = "export-excel-wrapper"
                    :data = "pricelist"
                    :before-generate="exportFile"
                    :fields = "priceFileds"
                    :header="priceHeader"
                    :name = "priceFileName">
                    <el-button plain type="primary" class="menu-btn">
                        导出
                    </el-button>
                </download-excel> -->
            </el-form>
            
        </div>

        <!--记录-->
        <div class="record">
             <el-table
                :data="datalist"
                border
                :header-cell-style="{
                    background: 'rgba(78,132,255,1)',
                    color: 'white',
                    textAlign: 'center',
                }"
                :cell-style="{
                    textAlign: 'center'
                }"
                :max-height="tableHeight"
                class="record-table"
                style="width: 100%">

                <el-table-column
                    prop="sitename"
                    width="120px"
                    label="申报单位">
                </el-table-column>

                <el-table-column
                    prop="time"
                    label="申报时间">
                </el-table-column>

                <el-table-column
                    prop="applicant"
                    label="申报人">
                </el-table-column>

                <el-table-column
                    prop="create_time"
                    width="95px"
                    label="提交时间">
                </el-table-column>

                <el-table-column
                    prop="plan_00"
                    width="50px"
                    label="00">
                </el-table-column>
                <el-table-column
                    prop="plan_01"
                    width="50px"
                    label="01">
                </el-table-column>
                <el-table-column
                    prop="plan_02"
                    width="50px"
                    label="02">
                </el-table-column>
                <el-table-column
                    prop="plan_03"
                    width="50px"
                    label="03">
                </el-table-column>
                <el-table-column
                    prop="plan_04"
                    width="50px"
                    label="04">
                </el-table-column>
                <el-table-column
                    prop="plan_05"
                    width="50px"
                    label="05">
                </el-table-column>
                <el-table-column
                    prop="plan_06"
                    width="50px"
                    label="06">
                </el-table-column>
                <el-table-column
                    prop="plan_07"
                    width="50px"
                    label="07">
                </el-table-column>
                <el-table-column
                    prop="plan_08"
                    width="50px"
                    label="08">
                </el-table-column>
                <el-table-column
                    prop="plan_09"
                    width="50px"
                    label="09">
                </el-table-column>
                <el-table-column
                    prop="plan_10"
                    width="50px"
                    label="10">
                </el-table-column>

                <el-table-column
                    prop="plan_11"
                    width="50px"
                    label="11">
                </el-table-column>
                <el-table-column
                    prop="plan_12"
                    width="50px"
                    label="12">
                </el-table-column>
                <el-table-column
                    prop="plan_13"
                    width="50px"
                    label="13">
                </el-table-column>
                <el-table-column
                    prop="plan_14"
                    width="50px"
                    label="14">
                </el-table-column>
                <el-table-column
                    prop="plan_15"
                    width="50px"
                    label="15">
                </el-table-column>
                <el-table-column
                    prop="plan_16"
                    width="50px"
                    label="16">
                </el-table-column>
                <el-table-column
                    prop="plan_17"
                    width="50px"
                    label="17">
                </el-table-column>
                <el-table-column
                    prop="plan_18"
                    width="50px"
                    label="18">
                </el-table-column>
                <el-table-column
                    prop="plan_19"
                    width="50px"
                    label="19">
                </el-table-column>

                <el-table-column
                    prop="plan_20"
                    width="50px"
                    label="20">
                </el-table-column>
                <el-table-column
                    prop="plan_21"
                    width="50px"
                    label="21">
                </el-table-column>
                <el-table-column
                    prop="plan_22"
                    width="50px"
                    label="22">
                </el-table-column>
                <el-table-column
                    prop="plan_23"
                    width="50px"
                    label="23">
                </el-table-column>

                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
                    </template>
                </el-table-column>

            </el-table>
            <!--分页-->
            <el-pagination
                v-if="datapage.total>0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="datapage.current"
                :page-sizes="[10, 20, 30, 100]"
                :page-size="datapage.size"
                layout="total, sizes, prev, pager, next, jumper"
                :total="datapage.total"
                class="pagination">
            </el-pagination>
        </div>


        <!-- 站点筛选--dialog -->
        <siteselect :show.sync="sitesDialog" v-on:siteSelectCompleted="siteSelectCompleted"></siteselect>

        <!---用汽申报编辑-->
        <el-dialog
            title="用气申报"
            :visible.sync="gasDialog"
            :append-to-body="true"
            class="gas-dialog"
            width="900px">
            <gaseditor :gas="gas" @ok="handleEditOk" v-if="gasDialog"/>
        </el-dialog>

    </div>
</template>

<script>
import {getGasList} from "@api/gas.js";


export default {
    name:"gastable",
    data(){
        return {
            start_date:'', //开始日期
            end_date:'', // 结束日期
            start_time:'', // 开始时间
            end_time:'', // 结束时间
            time_range:"day", // 时间范围下拉框
            sitesDialog:false, // 站点筛选对话框

            datapage:{
                current:1,
                size:10,
                total:0,
            }, // 分页信息

            datalist:[] , // 数据记录
            tableHeight:600, // 表格高度

            siteListStr:'', // 选中站点列表

            gasDialog:false, // 用汽申报记录
            gas:null, // 当前选中的用汽申报记录

        }
    },
    computed:{
        // 站点数据
        sites_config(){
            return this.$store.getters.getSitesConfigByPage();
        },
    },
    components:{
        siteselect: ()=>import("@components/SiteSelect"), // 站点筛选
        gaseditor:()=>import("./GasEditor.vue"), // 申报记录编辑
    },
    mounted(){
        // 页面初始化
        this.init();
        // 获取选中的站点数据 
        this.getSelectedSites();

        // 获取数据
        this.getDataList();
    },
    methods:{
        // 数据初始化
        init(){
            let $el=document.querySelector('.gas-wrap').parentNode;
            let offsetHeight=$el.offsetHeight;
            this.tableHeight=offsetHeight-200;
            // 清空引用
            $el=null;

            // 时间格式化
            let nowTime=this.$moment();
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间

            // 格式化结束日期和时间
            let endTime=nowTime.subtract(1, 'days');
            this.start_date= endTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=endTime.format('HH:mm'); // 开始时间

            // 当前选择时间
            this.time_range="day";

        },
        // 获取选中的站点列表
        getSelectedSites(siteList){
            //遍历全部站点，筛选出已被选中的站点
            //存放选中的数据
            siteList=siteList||this.sites_config.siteList;
            var selectSiteList = [];
            for (let groupId in siteList) {
                let groupSites = siteList[groupId];
                for (let siteId in groupSites) {
                    //拿到对应单个数据
                    let siteItem = groupSites[siteId];
                    if (siteItem.now == true) {
                        selectSiteList.push(siteItem);
                    }
                }
            }

            //得到选中站点的索引值
            var selectStr = "";
            for (var i = 0; i < selectSiteList.length; i++) {
                selectStr += selectSiteList[i].SiteNo + ",";
            }
            selectStr = selectStr.substr(0, selectStr.length - 1);
            // 保存选中的列表
            this.siteListStr = selectStr;

            // 进行数据请求
            this.searchData();
        },

        // 获取数据
        getDataList(start_time,end_time,siteListStr,page,size){
            // 开始时间
            let start_date=this.$moment(this.start_date);
            start_date=start_date.format('yyyy-MM-DD');
            start_time=start_time||( start_date+ " "+this.start_time);
            // 结束时间
            let end_date=this.$moment(this.end_date);
            end_date=end_date.format("yyyy-MM-DD");
            end_time=end_time||(end_date+" "+this.end_time);

            // 站点列表
            siteListStr=siteListStr||this.siteListStr;
            page=page||this.datapage.current;
            size=size||this.datapage.size;
            // 进行后台请求，获取分页信息，这里的返回值都是首字母大写的形式
            // 主要原因是因为历史遗留问题，原先的老板设置的字段名都是大写字母开头的
            // 所以在进行Mybatis配置的时候，就启用了首字母大写，于是就有了现在的样子，有的是小写，有的是大写
            getGasList(start_time,end_time,siteListStr,page,size).then(res=>{

                if(res.status&&res.status==200){
                    let content=res.content;
                    this.datalist=content.records;
                    // 保留分页信息
                    let page={
                        current:1,
                        size:10,
                        total:0,
                    };
                    page.current=content.current;
                    page.size=content.size;
                    page.total=content.total;
                    // 设置分页信息
                    this.datapage=page;
                }
            });
        },
        // 时间范围事件
        timeRangeChange(val){
            // 获取当前时间
            let nowTime=this.$moment();
            let startTime=nowTime;

            // 格式化结束日期和时间
            this.end_date=nowTime.format('yyyy-MM-DD'); // 开时日期
            this.end_time=nowTime.format('HH:mm'); // 开始时间
            switch (val){
                case "day":
                startTime=nowTime.add(-1,'day');
                break;
                case "week":
                startTime=nowTime.add(-1,'week');
                break;
                case "month":
                startTime=nowTime.add(-1,'month');
                break;
                case "year":
                startTime=nowTime.add(-1,'year');
                break;
                default:
                startTime=nowTime.add(-1,'day');
                break;
            }
            this.start_date= startTime.format('yyyy-MM-DD'); // 开时日期
            this.start_time=startTime.format('HH:mm'); // 开始时间
        },
        // 时间改变
        timeChange(){
            this.time_range="customize"; // 改为自定义
        },
        //站点选择完成之后
        siteSelectCompleted(selectedSites) {
            // 更新选中的站点数据
            this.getSelectedSites(selectedSites);
        },
        // 查询数据
        searchData(){
            this.getDataList("","","",1,this.datapage.size);
        },
        // 显示站点筛选
        showSitesSelect(){
            this.sitesDialog=true;
        },

        // 表格编辑
        handleEdit(row){
            this.gas=row;
            this.gasDialog=true; // 打开用汽申报对话框
        },
        // 确定
        handleEditOk(){
            this.gasDialog=false; // 关闭申报编辑
            // 重新查询列表
        },
        // 单价每页条数改变
        handleSizeChange(val){
            this.getDataList("","","",this.datapage.page,val);
        },
        // 单价页码改变
        handleCurrentChange(val){
              this.getDataList("","","",val,this.datapage.size);
        },

    }
}
</script>

<style lang="scss" scoped>
/**菜单栏 */
.menu-wrap{
    background: #fff;
    padding:10px;

    /**菜单栏按钮 */
    .menu-btn {
        height: 40px;
        margin-right: 5px;
        padding: 12px;
        margin-left: 5px;

        span {
            font-size: 16px;
            font-weight: 400;
            cursor: pointer;
        }
    }

    .date-input{
        width:135px;
        ::v-deep  input {
            width:130px;
            padding-right: 15px;
        }
    }

    .time-input{
        width:100px;

        ::v-deep input {
            width:90px;
            padding-right: 10px;
        }
    }
    /**时间范围 */
    ::v-deep .time_range{
        width:120px;
    }

    .el-form-item{
        margin-bottom: initial;
    }

    .export-excel-wrapper{
        display: inline-block;
    }

    .el-radio-button__inner{
        padding:12px;
    }
}

/** 
* 表格
*/
.record-table{
    ::v-deep .el-table__body-wrapper{
        max-height: 643px!important;
    }
}

.pagination{
    text-align: right;
}
</style>

<style lang="scss">
/** 用汽申报编辑 */
.gas-dialog{
    .el-dialog__body{
        padding:0 10px 10px 10px;
        max-height: 800px;
        overflow-x: hidden;
    }
}
</style>